import React from 'react'
import styled from 'styled-components'
import { GatsbyImage } from 'gatsby-plugin-image'
import { StoreButton } from 'components/StoreButton/StoreButton'
import { breakpointUpTo } from 'utils/breakpoints'
import { useStoresToDisplay } from '../../hooks/useStoresToDisplay'
import { StoreIcon } from '../../types/locale'
import { IImage } from '../../../graphql/types'

const ImgWrapper = styled.div`
  max-width: 589px;

  ${({ theme }) => breakpointUpTo(theme.breakpoints.md)} {
    max-width: 460px;
  }
  ${() => breakpointUpTo(768)} {
    max-width: 428px;
  }
`
const Heading = styled.h2`
  margin: 0;
  ${({ theme }) => theme.typography.LrgH2};

  ${({ theme }) => breakpointUpTo(theme.breakpoints.md)} {
    display: none;
  }
`
const MobileHeading = styled.h2`
  display: none;

  ${({ theme }) => breakpointUpTo(theme.breakpoints.md)} {
    display: inline;
    ${({ theme }) => theme.typography.MedH2}
  }
  ${() => breakpointUpTo(768)} {
    ${({ theme }) => theme.typography.SmH2}
  }
`
const Wrapper = styled.div`
  display: flex;
  padding: 0 ${({ theme }) => theme.space[8]};
  justify-content: center;
  align-items: center;
  background-color: ${({ theme }) => theme.colors.primary};
  gap: 97px;

  ${({ theme }) => breakpointUpTo(theme.breakpoints.md)} {
    gap: 0;
    padding: 0 ${({ theme }) => theme.space[5]};
  }
  ${() => breakpointUpTo(768)} {
    flex-direction: column;
    place-items: center;
  }
`
const StyledStoresContainer = styled.div`
  margin-top: ${({ theme }) => theme.space[5]};
  justify-content: flex-start;
  display: flex;
  & > a:first-child {
    margin-right: ${({ theme }) => theme.space[4]};
  }

  ${() => breakpointUpTo(768)} {
    margin-top: ${({ theme }) => theme.space[2]};
    justify-content: center;
    & > a:first-child {
      margin: 0;
    }
  }
`
const ContentWrapper = styled.div`
  max-width: 500px;
  text-align: left;

  ${() => breakpointUpTo(768)} {
    text-align: center;
    padding-top: ${({ theme }) => theme.space[5]};
  }
`
export type AppBannerProps = {
  text: string
  mobileText: string
  storesIcons: StoreIcon[]
  image: IImage
}
export const AppBanner = ({
  text,
  mobileText,
  storesIcons,
  image,
}: AppBannerProps) => {
  const stores = useStoresToDisplay(storesIcons)

  return (
    <Wrapper>
      <ContentWrapper>
        <Heading>{text}</Heading>
        <MobileHeading>{mobileText}</MobileHeading>
        <StyledStoresContainer>
          {stores.map(({ id, ...rest }) => (
            <StoreButton key={id} {...rest} />
          ))}
        </StyledStoresContainer>
      </ContentWrapper>
      <ImgWrapper>
        <GatsbyImage
          image={image.image.gatsbyImageData}
          alt={image.alternativeText}
        />
      </ImgWrapper>
    </Wrapper>
  )
}
